<template>
  <MainLayout page-name="invoice-operation">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col class="header-button-col">
          <el-button type="primary" class="operation" @click="clickOperation">当月確定</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
      >
        <BillingYm v-model="simpleSearchFormModel.billing_ym" :searchCond="true" :initialize="true" mode="this" :required="true" />
        <StatusCode v-model="simpleSearchFormModel.status_code" :searchCond="true" :initialize="true" mode="search" label="" />
      </SimpleSearch>
    </PageHeader>
      <!-- :model="{invoiceModel,emailModel}" -->
    <TableInvoice
      :model="rowModel"
      :table-data="tableData"
      :dataFormatter="csvDataFormatter"
      :default-sort="{ prop: 'bill_to_code', order: 'ascending' }"
      :status_code="select_status_code"
      :multiSelect="true"
      :selectable="selectable"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
      @clickExcel="clickExcel"
      @clickPdf="clickPdf"
      @clickEmail="clickMail"
    >
      <template #columns>
        <!-- <BillToCodeColumn label="請求先" :sortable="true" />
        <StatusCodeColumn v-model="status_code" :sortable="true" prop="status_code_name" />
        <InvoiceTypeColumn v-model="invoiceModel.invoice_type" prop="invoice_type" :sortable="true" :required="true" :searchCond="true" :initialize="true" :defaultBlank="false" :enabled='tableData.status_code!="0"&&tableData.status_code!="5"'/>
        <BillingDateColumn label="請求日" prop="billing_date" :sortable="true" :billing_ym="simpleSearchFormModel.billing_ym" order="ascending" :defaultBlank="false" :enabled='tableData.status_code!="0"&&tableData.status_code!="5"'/>
        <TransferMonthDayColumn label="振込日" prop="transfer_month_day" :sortable="true" :billing_ym="simpleSearchFormModel.billing_ym" order="descending" :defaultBlank="false" :enabled='tableData.status_code!="0"&&tableData.status_code!="5"'/>
        <BlankColumn /> -->
        <!-- <BillToCodeColumn label="請求先" />
        <StatusCodeColumn v-model="status_code" prop="status_code_name" />
        <InvoiceTypeColumn v-model="invoiceModel.invoice_type" prop="invoice_type" :required="true" :searchCond="true" :initialize="true" :defaultBlank="false" :enabled='tableData.status_code!="0"&&tableData.status_code!="5"'/>
        <BillingDateColumn label="請求日" prop="billing_date" :billing_ym="simpleSearchFormModel.billing_ym" order="ascending" :defaultBlank="false" :enabled='tableData.status_code!="0"&&tableData.status_code!="5"'/>
        <TransferMonthDayColumn label="振込日" prop="transfer_month_day" :billing_ym="simpleSearchFormModel.billing_ym" order="descending" :defaultBlank="false" :enabled='tableData.status_code!="0"&&tableData.status_code!="5"'/> -->
        <!-- 20220512髙森追記 -->
        <!-- <EmailTargetColumn v-model="emailModel.email_target" prop="email_target" :required="true" :searchCond="true" :initialize="true" :defaultBlank="false" :enabled='tableData.status_code!="0"&&tableData.status_code!="5"'/> -->
        <!-- ここまで -->
        <BillToCodeColumn v-model="rowModel.billToCode" prop="bill_to_code" />
        <StatusCodeColumn v-model="rowModel.statusCode" prop="status_code_name" />
        <InvoiceTypeColumn v-model="rowModel.invoiceType" prop="invoice_type" :required="true" :searchCond="true" :initialize="true" :defaultBlank="false" :enabled='tableData.status_code!="0"&&tableData.status_code!="5"'/>
        <BillingDateColumn v-model="rowModel.billingDate" prop="billing_date"  :billing_ym="simpleSearchFormModel.billing_ym" order="ascending" :defaultBlank="false" :enabled='tableData.status_code!="0"&&tableData.status_code!="5"'/>
        <TransferMonthDayColumn v-model="rowModel.transferMonthDay" prop="transfer_month_day" :billing_ym="simpleSearchFormModel.billing_ym" order="descending" :defaultBlank="false" :enabled='tableData.status_code!="0"&&tableData.status_code!="5"'/>
        <EmailTargetColumn v-model="rowModel.emailTarget" prop="email_target" :required="true" :searchCond="true" :initialize="true" :defaultBlank="false" :enabled='tableData.status_code!="0"&&tableData.status_code!="5"'/>
        <BlankColumn />
      </template>
    </TableInvoice>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import StatusCode from '@/components/molecules/form/select/StatusCode.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
// import TableInvoice from '@/components/molecules/table/TableInvoice.vue'
import TableInvoice from '@/components/molecules/table/TableInvoicePaging.vue'
// import BillingYmColumn from '@/components/molecules/table/BillingYmColumn.vue'
import BillToCodeColumn from '@/components/molecules/table/BillToCodeColumn.vue'
import StatusCodeColumn from '@/components/molecules/table/StatusCodeColumn.vue'
import InvoiceTypeColumn from '@/components/molecules/table/InvoiceTypeColumn.vue'
// 20220512髙森追記
import EmailTargetColumn from '@/components/molecules/table/EmailTargetColumn.vue'
// ここまで
import BillingDateColumn from '@/components/molecules/table/BillingDateColumn.vue'
import TransferMonthDayColumn from '@/components/molecules/table/TransferMonthDayColumn.vue'
import BlankColumn from '@/components/molecules/table/BlankColumn.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    BillingYm,
    StatusCode,
    SimpleSearch,
    TableInvoice,
    // BillingYmColumn,
    InvoiceTypeColumn,
    // 20220512髙森追記
    EmailTargetColumn,
    // ここまで
    BillToCodeColumn,
    StatusCodeColumn,
    BillingDateColumn,
    TransferMonthDayColumn,
    BlankColumn
  },
  data () {
    return {
      title: '請求書一覧',
      tableData: [],
      simpleSearchFormModel: {
        billing_ym: this.getDefaultBillingYm(),
        status_code: ''
      },
      // invoiceModel: {
      //   invoice_type: ''
      // },
      // // 20220512髙森追記
      // emailModel: {
      //   email_target: ''
      // },
      // // ここまで
      rowModel: {
        billToCode: undefined,
        statusCode: undefined,
        invoiceType: undefined,
        billingDate: undefined,
        transferMonthDay: undefined,
        emailTarget: undefined
      },
      // currentRow: {},
      select_status_code: {
        type: String,
        default: ''
      }
    }
  },
  computed: {},
  mounted () {
    sessionStorage.removeItem('invoiceOperationSearchCond')
  },
  methods: {
    // changeSelect () {
    //   this.tableData = []
    // },
    selectable (row, index) {
      // 選択可能条件
      return (row.invoice_type && row.billing_date && row.transfer_month_day && row.email_target)
    },
    async clickOperation (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0007W'))) {
        return
      }
      this.$loadingMask.on()
      const params = {}
      params.billing_ym = this.simpleSearchFormModel.billing_ym
      // params.login_user_id = this.$session.get('login-user').user_id

      return this.$axios.put('/invoice-operation', params)
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          var currentBillingYm = new Date(params.billing_ym.substr(0, 4) + '/' + params.billing_ym.substr(4, 2) + '/1')
          currentBillingYm.setMonth(currentBillingYm.getMonth() + 1)
          var nextBillingYm = currentBillingYm.getFullYear() + String(currentBillingYm.getMonth() + 1).padStart(2, '0')
          this.$session.set('latestBillingYM', nextBillingYm)
          // this.simpleSearchFormModel.billing_ym = nextBillingYm
          this.search()
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    clickSearch () {
      sessionStorage.setItem('invoiceOperationSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.select_status_code = this.simpleSearchFormModel.status_code.trim()
      this.search()
    },
    async search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('invoiceOperationSearchCond'))
      // searchCond.login_user_id = this.$session.get('login-user').user_id
      this.tableData = []
      searchCond.latest_billing_ym = this.getDefaultBillingYm()
      await this.$axios
        .get('/search-invoice-operation', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch () {
      this.search()
    },
    parameterSet (rows, syori) {
      var params = []
      for (let i = 0; i <= rows.length - 1; i++) {
        var param = {}
        param.billing_ym = rows[i].billing_ym
        param.bill_to_code = rows[i].bill_to_code
        param.status_code = rows[i].status_code
        param.updated_on = rows[i].updated_on
        param.email_target = rows[i].email_target
        switch (syori) {
          case 'Excel':
            param.invoice_type = rows[i].invoice_type
            param.billing_date = rows[i].billing_date
            param.transfer_month_day = rows[i].transfer_month_day
            break
          case 'PDF':
            param.excel_file_name = rows[i].excel_file_name
            param.pdf_file_name = rows[i].pdf_file_name
            break
          case 'Mail':
            break
          default:
        }
        params.push(param)
      }
      return params
    },
    async clickExcel (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0005W', '請求書Excel'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        // .put('/create-excel', { data: rows })
        .put('/create-excel', { data: this.parameterSet(rows, 'Excel'), syori: 'Excel' })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                this.search()
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    async clickPdf (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0005W', '請求書PDF'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        // .put('/create-pdf', { data: rows })
        .put('/create-pdf', { data: this.parameterSet(rows, 'PDF'), syori: 'PDF' })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                this.search()
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    async clickMail (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0006W'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        // .put('/send-email', { data: rows })
        .put('/send-email', { data: this.parameterSet(rows, 'Mail'), syori: 'Mail' })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                this.search()
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button-col {
  height:40px;
}
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.dummy {
  display: none;
}
th.billing-ym{
  display: none;
}
td.billing-ym{
  display: none;
}
</style>
